<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      seatStatus: 'seat/getSeatStatus',
      isPayingUser: 'seat/getIsPayingUser',
      isCallingSelfcheck: 'seat/getIsCallingSelfcheck',
      isDoingSelfcheck: 'seat/getIsDoingSelfcheck',
      isFinishedSelfcheck: 'seat/getIsFinishedSelfcheck',
      isShowingSelfcheckModal: 'modal/isShowingSelfcheckModal',
      isShowingSelfcheckCallingModal: 'modal/isShowingSelfcheckCallingModal',
      error: 'selfcheck/getError',
    }),
    isInSelfcheckReloadPage() {
      return this.$route.name === 'selfcheckReload'
    },
    isApp() {
      return process.env.VUE_APP_TYPE === 'app'
    },
  },
  watch: {
    seatStatus(next, prev) {
      if (next === 0) {
        this.hideSelfcheckModalsIfNeeded()
        this.recoverFromSelfcheck()
        return
      }
      if (this.isCallingSelfcheck) {
        this.handleCallingSelfcheck()
        return
      }
      if (this.isDoingSelfcheck) {
        this.handleDoingSelfcheck(prev)
        return
      }
      if (this.isFinishedSelfcheck) {
        this.handleFixAmount(prev)
        return
      }
    },
  },
  methods: {
    ...mapActions({
      fetchSeatAmount: 'selfcheck/fetchSeatAmount',
      cancelSelfcheck: 'selfcheck/cancelSelfcheck',
      setShowingSelfcheckModal: 'modal/setShowingSelfcheckModal',
      setShowingSelfcheckCallingModal: 'modal/setShowingSelfcheckCallingModal',
      setShowingSimpleErrorModal: 'modal/setShowingSimpleErrorModal',
      setShowingSelfcheckErrorModal: 'modal/setShowingSelfcheckErrorModal',
    }),
    isInitialStatus(status) {
      return status === -1
    },
    hideSelfcheckModalsIfNeeded() {
      if (this.isShowingSelfcheckModal) this.setShowingSelfcheckModal(false)
      if (this.isShowingSelfcheckCallingModal) this.setShowingSelfcheckCallingModal(false)
    },
    recoverFromSelfcheck() {
      if (this.$route.path.includes('selfcheck')) {
        this.navigateToTop()
      }
    },
    handleCallingSelfcheck() {
      if (this.isPayingUser) return
      this.setShowingSelfcheckCallingModal(true)
    },
    handleDoingSelfcheck(prevStatus) {
      if (this.isInitialStatus(prevStatus)) {
        if (this.isPayingUser) {
          if (this.isApp) {
            this.cancel()
          } else {
            this.navigateToSelfcheckReloadIfNeeded()
          }
        } else {
          this.setShowingSelfcheckModal(true)
        }
      } else {
        if (this.isPayingUser) return
        this.setShowingSelfcheckModal(true)
      }
    },
    async handleFixAmount(prevStatus) {
      if (this.isPayingUser && !this.isInitialStatus(prevStatus)) return
      await this.fetchSeatAmount()
      this.setShowingSelfcheckModal(false)
      this.navigateToCheckIfNeeded()
    },
    async cancel() {
      await this.cancelSelfcheck({ callStaff: false })

      if (this.error) {
        this.setShowingSelfcheckErrorModal(true)
      }
    },
    navigateToTop() {
      this.$router.replace({ name: 'shopMenu' })
    },
    navigateToSelfcheckReloadIfNeeded() {
      if (this.$route.name !== 'selfcheckReload') {
        this.$router.replace({ name: 'selfcheckReload' })
      }
    },
    navigateToCheckIfNeeded() {
      if (this.$route.name !== 'check') {
        this.$router.push({ name: 'check' })
      }
    },
  },
  render(h) {
    return h() // avoid empty template warning message
  },
}
</script>
